const CONFIG = {
  //hlsUrl: "https://localhost:44321/stream/live.m3u8",
  //hlsUrl: "http://192.169.0.150:5000/stream/live.m3u8",
  hlsUrl: "https://api.vip-radio.online/stream/live.m3u8",
  //hubUrl: "https://localhost:44321/radiohub",
  //hubUrl: "http://192.168.0.150:5000/radiohub",
  hubUrl: "https://api.vip-radio.online/radiohub",
  //apiBase: "https://localhost:44321/api"
  //apiBase: "http://192.168.0.150:5000/api"
  apiBase: "https://api.vip-radio.online/api"
};

export default CONFIG;